//C:\Users\Ahmad\Desktop\academies\frontend\src\api\academyAuth.js
import axios from "@/axios";

export async function academyLogin(data) {
  const res = await axios.post("/api/academy/login", data);
  return res.data;
}

export async function fetchAcademyMe() {
  const res = await axios.get("/api/academy/me");
  return res.data;
}

export async function academyLogout() {
  await axios.post("/api/academy/logout");
}




// 🟢 جلب جميع المدرّبين للأكاديمية
export async function fetchTrainers() {
  const res = await axios.get("/api/academy/trainers");
  return res.data;
}

// 🟢 إنشاء مدرّب جديد
export async function createTrainer(data) {
  const res = await axios.post("/api/academy/trainers", data);
  return res.data;
}



// 🟢 جلب خطط الأكاديمية
export async function fetchAcademyPlans() {
  const res = await axios.get("/api/academy/plans");
  return res.data.plans;
}

// 🟢 إنشاء خطة جديدة للأكاديمية
export async function createAcademyPlan(data) {
  const res = await axios.post("/api/academy/plans", data);
  return res.data.plan;
}

// 🟢 تحديث خطة للأكاديمية
export async function updateAcademyPlan(id, data) {
  const res = await axios.put(`/api/academy/plans/${id}`, data);
  return res.data.plan;
}

// 🟢 حذف خطة للأكاديمية
export async function deleteAcademyPlan(id) {
  const res = await axios.delete(`/api/academy/plans/${id}`);
  return res.data;
}


// 🟢 جلب FAQ الأكاديمية
export async function fetchAcademyFaqs() {
  const res = await axios.get("/api/academy/faqs");
  return res.data.faqs;
}

// 🟢 إنشاء FAQ جديد
export async function createAcademyFaq(data) {
  const res = await axios.post("/api/academy/faqs", data);
  return res.data.faq;
}

// 🟢 تحديث FAQ
export async function updateAcademyFaq(id, data) {
  const res = await axios.put(`/api/academy/faqs/${id}`, data);
  return res.data.faq;
}

// 🟢 حذف FAQ
export async function deleteAcademyFaq(id) {
  const res = await axios.delete(`/api/academy/faqs/${id}`);
  return res.data;
}

/**
 * 🟢 جلب الفئات (الرئيسية + الفرعية) للأكاديمية
 */
export async function fetchAcademyCategories() {
  const res = await axios.get("/api/academy/categories");
  return res.data.categories;
}

/**
 * 🟢 إنشاء فئة جديدة (رئيسية أو فرعية)
 */
export async function createAcademyCategory(data) {
  const res = await axios.post("/api/academy/categories", data);
  return res.data.category;
}

/**
 * 🟢 حذف فئة
 */
export async function deleteAcademyCategory(id) {
  await axios.delete(`/api/academy/categories/${id}`);
}

// ================= Contacts (Academy) =================
// ================= Contacts (Academy) =================
export async function fetchAcademyContacts() {
  const res = await axios.get("/api/academy/contacts");
  return res.data.contacts; // ✅
}

export async function createAcademyContact(data) {
  // ✅ backend expects label not title
  const payload = {
    label: data.title,
    url: data.url,
    icon: data.icon,
    is_active: data.is_active,
  };

  const res = await axios.post("/api/academy/contacts", payload);
  return res.data;
}

export async function updateAcademyContact(id, data) {
  const payload = {
    label: data.title,
    url: data.url,
    icon: data.icon,
    is_active: data.is_active,
  };

  const res = await axios.put(`/api/academy/contacts/${id}`, payload);
  return res.data;
}

export async function deleteAcademyContact(id) {
  const res = await axios.delete(`/api/academy/contacts/${id}`);
  return res.data;
}
